export default "__VITE_ASSET__BWzXBjBw__"